import React, { useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';
import { IconImages } from '../../styles/icons.js';
import VideoPlayer from 'simple-react-video-thumbnail';

const FileDetails = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 67px;
  min-height: 67px;
  font-size: 14px;
  .video-player {
    margin-left: 22px;
  }

  .video-player, video, .video-player__thumbnail-container img, .video-player__thumbnail-container {
    height: 30px;
    width: 30px;
    border-radius: 7px;

    img {
      object-fit: cover;
    }
  }

  .video-player__icon-container {
    display: none;
  }
`;

const MainDiv = styled.div`
  border-radius: 10px;
  width: 90%;
  max-width: 680px;
  margin-left: auto;
  margin-right: auto;
  -webkit-box-shadow: 0px 4px 24px -4px rgba(227,224,227,1);
  -moz-box-shadow: 0px 4px 24px -4px rgba(227,224,227,1);
  box-shadow: 0px 4px 24px -4px rgba(227,224,227,1);
  @media (prefers-color-scheme: dark) {
    -webkit-box-shadow: 0px 0px 7px 2px rgba(66,63,66,1);
    -moz-box-shadow: 0px 0px 7px 2px rgba(66,63,66,1);
    box-shadow: 0px 0px 7px 2px rgba(66,63,66,1);
  }
  margin-bottom: 16px;
  padding: 10px 0;
`;

const FileName = styled.span`
  overflow-wrap: break-word;
  margin-left: 22px;
`;

const Failure = styled.div`
  background-color: rgba(255, 255, 255, 0.08);
  max-width: 165px;
  width: 150px;
  height: 37px;
  border-radius: 8px;
  margin-left: auto;
  margin-right: 20px;
  color: #B6B6B6;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 12px;
  padding-right: 10px;
  font-family: Inter, sans-serif;
`;

const MergeVideoItem = ({ fileWithMeta }) => {
  const [fileData, setFileData] = useState({ localUrl: '', thumb: '' });
  const videoPlayerRef = useCallback(() => {}, []);

  useEffect(() => {
    let url;

    if (fileWithMeta && fileWithMeta.file) {
      const u = window.URL || window.webkitURL;
      if (u) {
        url = u.createObjectURL(fileWithMeta.file);
        setFileData({ thumb: '', localUrl: url });
      }
    }

    return () => {
      if (url) {
        try {
          (window.URL || window.webkitURL).revokeObjectURL(url);
        } catch (e) {
          // ignore
        }
      }
    };
  }, [fileWithMeta]);

  return (
    <FileDetails>
      {fileData.localUrl && (
        <VideoPlayer videoUrl={fileData.localUrl} snapshotAt={3} ref={videoPlayerRef} />
      )}
      <FileName style={{ overflowWrap: 'anywhere', width: '65%' }}>{fileWithMeta?.meta?.name}</FileName>
      {fileWithMeta.error ? (
        <Failure>
          File upload failed
          <IconImages type={'error'} style={{ width: 28 }} />
        </Failure>
      ) : null}
    </FileDetails>
  );
};

const MergeVideoPreview = ({ mergeVideos = [] }) => (
  <MainDiv style={{ flexDirection: 'column' }}>
    {mergeVideos.map((data, i) => (
      <MergeVideoItem key={i + (data?.meta?.name || '')} fileWithMeta={data} />
    ))}
  </MainDiv>
);

export default MergeVideoPreview;
